import { createActionTypes } from "../../create_action_types";

/**
 * Create action creator for incrementing page for a context
 * @param {string} resourceName
 * @returns {function}
 */
export function createIncrementPageActionCreator(resourceName) {
  const actionTypes = createActionTypes(resourceName);
  return queryObject => {
    return {
      type: actionTypes.incrementPage,
      payload: {
        queryObject
      }
    };
  };
}
